'use strict';
import isFunction from 'lodash/isFunction';
import {createEventHandler} from 'recompose';
import {Observable} from 'rxjs';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/last';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';


export function buildDraggable(props$) {
  const {
    handler: onDragEnter,
    stream: dragEnter$,
  } = createEventHandler();
  const {
    handler: onDragLeave,
    stream: dragLeave$,
  } = createEventHandler();
  const {
    handler: onDragOver,
    stream: dragOver$,
  } = createEventHandler();
  const {
    handler: onDrop,
    stream: drop$,
  } = createEventHandler();

  const isDragging$ = Observable
    .merge(
      dragEnter$.map(mapToName('dragEnter')),
      dragLeave$.map(mapToName('dragLeave')),
      dragOver$.map(mapToName('dragOver')),
      drop$.map(mapToName('drop')),
    )
    .map(({e, eventName}) => {
      e.preventDefault();
      e.stopPropagation();

      switch (eventName) {
        case 'dragEnter':
        case 'dragOver':
          return true;

        case 'dragLeave':
        case 'drop':
          return false;
      }
    })
    .startWith(false)
    .scan((acc, curr) => curr)
    .distinctUntilChanged();

  drop$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      e.preventDefault();
      if (isFunction(props.onDrop)) {
        props.onDrop(e);
      }
    });

  return {
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
    isDragging$,
  };
}

function mapToName(eventName) {
  return e => ({e, eventName});
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-utils/Draggable.js